module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Training/training-approval/training-approval-form/training-approval-form.component.css
// module id = ./src/app/hrms/Training/training-approval/training-approval-form/training-approval-form.component.css
// module chunks = main